import Link from 'next/link';

import { Button, ButtonType } from '@lamesarv-sdk/components';

import { SecondarySection } from './GridFavoritesLayout';
import { IRvType } from '@/types/cms';

interface GridFavoritesEmptyProps {
  rvTypes: IRvType[];
}

export const GridFavoritesEmpty = ({ rvTypes }: GridFavoritesEmptyProps) => (
  <>
    <div
      className="border border-[#9EA1A3] border-dashed flex flex-col items-center gap-3 md:gap-4 px-8 py-14 md:py-28 rounded-[0.625rem]"
      data-testid="favorites-container"
    >
      <h2 className="font-bold text-lg md:text-2xl">Your Adventure Awaits!</h2>
      <p className="text-[#3F585E] text-center text-xs md:text-base">
        You haven't favorited any RVs yet. Explore our top picks and start building your dream RV collection today!
      </p>
      <Link prefetch href="/search">
        <Button
          type={ButtonType.primary}
          title="Browse all RVs"
          className="rounded mt-1"
          classNameTitle="md:text-lg"
          dataTestId="browse-all"
        />
      </Link>
    </div>
    <SecondarySection title="Browse by RV Types" description="Explore the possibilities and pick your style.">
      <div
        className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-x-5 gap-y-4 md:gap-x-8 md:gap-y-8"
        data-testid="browse-tv-types-container"
      >
        {rvTypes.map((item, index) => (
          <Link
            href={item.link}
            key={item.title + index}
            className="bg-white border border-[#DCDDDE] rounded-[0.625rem] flex flex-col gap-[1.125rem] px-5 py-6 lg:px-7 lg:py-8 items-center justify-end hover:bg-gray-50"
          >
            <img src={item.icon_url} alt={item.title} className="w-full max-w-[9.5rem]" />
            <p className="font-medium text-xs md:text-base">{item.title}</p>
          </Link>
        ))}
      </div>
    </SecondarySection>
  </>
);
